import '../css/RouteCard.css'
import "swiper/css/navigation";
import "swiper/css";

const RouteCard = ({img, name, kms, hours, desc, tempo, mountain, info, onClick, i18n}) => {
    let lang = i18n.language
    return(
                <div className="route_card" style={{
                    backgroundImage: `url(${img})`
                }} onClick={onClick}>
                    <div></div>
                    <div>{name?.[lang]}</div>
                    <div className='desc'>{desc[lang]}</div>
                    <div>
                        <div data-id="kms">{kms?.[lang]}</div>
                        <div data-id="hours">{hours?.[lang]}</div>
                        <div data-id="tempo_yellow">{tempo?.[lang]}</div>
                        <div data-id="mountain">{mountain?.[lang]}</div>
                    </div>
                </div>
    )
}

export default RouteCard;